var _path, _mask, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.48 1.2926C22.8562 -0.0793032 25.7838 -0.0793031 28.16 1.2926L42.096 9.33855C44.4722 10.7104 45.936 13.2458 45.936 15.9896V32.0815C45.936 34.8253 44.4722 37.3607 42.096 38.7326L28.16 46.7785C25.7838 48.1504 22.8562 48.1504 20.48 46.7785L6.54398 38.7326C4.16778 37.3607 2.70398 34.8253 2.70398 32.0815V15.9896C2.70398 13.2458 4.16778 10.7104 6.54398 9.33855L20.48 1.2926Z",
    fill: "url(#paint0_linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 44,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.48 1.2926C22.8562 -0.0793031 25.7838 -0.079303 28.16 1.2926L42.096 9.33855C44.4722 10.7104 45.936 13.2458 45.936 15.9896V32.0815C45.936 34.8253 44.4722 37.3607 42.096 38.7326L28.16 46.7785C25.7838 48.1504 22.8562 48.1504 20.48 46.7785L6.54398 38.7326C4.16778 37.3607 2.70398 34.8253 2.70398 32.0815V15.9896C2.70398 13.2458 4.16778 10.7104 6.54398 9.33855L20.48 1.2926Z",
    fill: "url(#paint1_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7205 25.3383C13.5231 19.808 17.0357 14.3541 22.566 13.1568C28.0963 11.9594 33.5502 15.472 34.7475 21.0023L35.8787 26.2267L15.8516 30.5627L14.7205 25.3383Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9712 11.4623C15.1185 12.9459 10.7659 19.704 12.2496 26.5568L13.6492 33.0212C13.65 33.0277 13.6511 33.0342 13.6525 33.0406C13.846 33.9344 19.5582 33.4563 26.411 31.9726C33.2638 30.4889 38.6622 28.5615 38.4687 27.6677C38.4679 27.6644 38.4672 27.6611 38.4663 27.6579L38.4674 27.6577L37.0657 21.1839C35.5821 14.3311 28.824 9.97858 21.9712 11.4623Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.8652,
    cy: 28.3947,
    rx: 10.2455,
    ry: 1.33637,
    transform: "rotate(-12.2164 25.8652 28.3947)",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0339,
    cy: 28.5732,
    rx: 8.16236,
    ry: 0.901101,
    transform: "rotate(-12.2164 26.0339 28.5732)",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0594,
    cy: 30.3441,
    rx: 12.6956,
    ry: 1.65594,
    transform: "rotate(-12.2164 26.0594 30.3441)",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0125 30.8844C37.0649 30.8032 37.0847 30.7274 37.0697 30.658C36.8985 29.8674 32.2736 30.1979 26.7396 31.396C21.2057 32.5941 16.8583 34.2063 17.0294 34.9969C17.0445 35.0663 17.0938 35.1271 17.1751 35.1794L17.0737 35.2013L20.3942 50.5382C21.5924 56.0722 27.0498 59.5871 32.5838 58.3889C38.1178 57.1908 41.6326 51.7333 40.4345 46.1994L37.1139 30.8625L37.0125 30.8844Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3668 32.5202C37.4191 32.4389 37.4389 32.3632 37.4239 32.2938C37.2528 31.5032 32.6278 31.8336 27.0939 33.0317C21.5599 34.2299 17.2125 35.8421 17.3837 36.6326C17.3987 36.702 17.4481 36.7628 17.5294 36.8151L17.4279 36.8371L20.3943 50.5381C21.5925 56.072 27.0499 59.5869 32.5839 58.3887C38.1178 57.1906 41.6327 51.7331 40.4345 46.1992L37.4682 32.4982L37.3668 32.5202Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0297 30.06C38.0873 29.9674 38.1088 29.8809 38.0916 29.8013C37.8954 28.8954 32.7541 29.2397 26.6082 30.5703C20.4622 31.901 15.639 33.7141 15.8351 34.62C15.8523 34.6996 15.9077 34.7695 15.9985 34.8299L15.8858 34.8543L19.3619 50.9095C20.6926 57.0555 26.7535 60.959 32.8995 59.6284C39.0454 58.2977 42.949 52.2368 41.6184 46.0908L38.1423 30.0356L38.0297 30.06Z",
    fill: "url(#paint9_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7264 34.257C30.7316 35.7005 29.4539 37.2155 28.0423 38.2913L27.9593 38.3545L27.8576 38.3313C23.5462 37.3455 20.8819 34.725 19.8674 33.5861L20.2001 33.2898C21.1776 34.3872 23.732 36.8992 27.855 37.8733C29.1833 36.8403 30.3994 35.3976 31.3596 34.0042C32.3405 32.5809 33.042 31.2273 33.3203 30.4415L33.7402 30.5902C33.4444 31.4254 32.7204 32.8146 31.7264 34.257Z",
    fill: "#299AFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6425 35.4371C32.2578 37.4004 30.4839 39.4584 28.5312 40.921L28.4495 40.9822L28.3498 40.9603C22.4065 39.6534 18.7447 36.1243 17.3509 34.5887L17.6807 34.2893C19.0366 35.783 22.5887 39.2068 28.3456 40.503C30.2157 39.0822 31.9283 37.0945 33.2785 35.1803C34.6491 33.2371 35.6337 31.3874 36.0275 30.3093L36.4459 30.4622C36.0341 31.5898 35.0264 33.475 33.6425 35.4371Z",
    fill: "#299AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0652 47.4111C18.3945 47.1234 18.6985 43.3175 17.7444 38.9104C17.4657 37.6233 17.1105 36.4272 16.7141 35.386C15.015 37.0068 13.9813 39.855 13.8602 43.2066C14.8365 45.8847 16.091 47.6221 17.0652 47.4111Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5057 47.3808C44.1274 45.4193 42.5077 42.4134 41.0285 38.9314C39.489 35.3075 38.4263 31.932 38.0027 29.5598C40.7852 31.0479 43.4026 34.4699 44.7844 38.8779C45.7358 41.9127 45.9395 44.8982 45.5057 47.3808Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92988 34.9821C6.41494 34.4502 6.38152 33.4989 7.10507 33.3422C9.20819 32.8869 11.2822 34.2227 11.7376 36.3258C12.058 37.8056 11.4916 39.271 10.3951 40.1683C9.94864 40.5336 9.34527 40.1857 9.22321 39.6219C8.80294 37.6808 7.95038 36.0362 6.92988 34.9821Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.56939,
    ry: 5.56939,
    transform: "matrix(-0.977355 0.211605 0.211605 0.977355 14.2705 39.5432)",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.206 20.4308C31.2849 20.5209 31.4426 20.4731 31.4172 20.3561C31.209 19.3943 30.2605 18.7834 29.2987 18.9916C28.3369 19.1999 27.726 20.1484 27.9343 21.1102C27.9596 21.2272 28.123 21.2055 28.1575 21.0908C28.3385 20.4907 28.8312 20.0043 29.4872 19.8623C30.1432 19.7202 30.7931 19.9593 31.206 20.4308Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4044 22.5981C23.3483 22.534 23.2362 22.568 23.2543 22.6512C23.4022 23.3345 24.0761 23.7686 24.7594 23.6206C25.4428 23.4727 25.8768 22.7988 25.7289 22.1154C25.7109 22.0322 25.5948 22.0477 25.5702 22.1292C25.4416 22.5555 25.0915 22.901 24.6255 23.0019C24.1595 23.1028 23.6979 22.933 23.4044 22.5981Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1343 23.8584C20.0243 23.6657 21.111 23.3246 20.9278 22.4326C20.9256 22.422 20.9234 22.4113 20.9211 22.4006C20.6348 21.0782 19.5255 20.196 18.4435 20.4303C17.3615 20.6645 16.7164 21.9265 17.0027 23.249C17.0063 23.2656 17.0101 23.2822 17.0139 23.2986C17.2118 24.1441 18.2856 24.0421 19.1343 23.8584Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2934 39.5483C33.2011 39.5683 33.1048 39.5526 33.026 39.5038L29.7603 37.4992C28.9043 36.9735 28.6651 35.8685 29.227 35.0358C29.4987 34.6341 29.9164 34.3544 30.4036 34.2489C30.8907 34.1434 31.3871 34.2252 31.8003 34.4787L32.2564 34.7588L32.556 34.3154C32.8276 33.9133 33.2453 33.6336 33.7328 33.5281C34.2196 33.4227 34.716 33.5045 35.1292 33.758C35.9855 34.2836 36.2248 35.3886 35.6629 36.2212L33.5188 39.3974C33.4669 39.4742 33.386 39.5283 33.2934 39.5483Z",
    fill: "#FF3E1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0417 33.0742C20.1619 33.0482 20.2804 33.1245 20.3065 33.2448C20.5727 34.4745 21.3137 37.4758 22.1461 39.6485C22.1901 39.7634 22.1326 39.8922 22.0178 39.9362C21.9029 39.9802 21.7741 39.9227 21.7301 39.8079C20.8856 37.6036 20.139 34.5764 19.8711 33.339C19.8451 33.2188 19.9214 33.1002 20.0417 33.0742Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3535 30.1521C33.4738 30.1261 33.591 30.1961 33.6153 30.3085C33.8643 31.4584 34.5628 34.2637 35.3636 36.2906C35.4059 36.3978 35.3469 36.5193 35.2318 36.5622C35.1167 36.605 34.989 36.5528 34.9467 36.4457C34.1342 34.3894 33.4305 31.5599 33.1799 30.4028C33.1556 30.2904 33.2333 30.1781 33.3535 30.1521Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8864 11.3935C21.4737 10.1154 21.753 8.70965 21.9443 8.15918L22.3651 8.30543C22.1918 8.80401 21.9381 10.104 22.3103 11.2566L21.8864 11.3935Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.3442,
    cy: 40.5518,
    rx: 1.5591,
    ry: 1.55911,
    transform: "rotate(-12.2164 22.3442 40.5518)",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5525,
    cy: 6.77874,
    rx: 1.78183,
    ry: 1.78183,
    transform: "rotate(-12.2164 22.5525 6.77874)",
    fill: "url(#paint15_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2187 36.2473C34.0442 36.5016 33.2982 37.6599 33.5525 38.8344L33.6245 39.167C33.6246 39.1673 33.6246 39.1677 33.6247 39.168L33.9575 40.7052C34.0977 41.3526 34.7361 41.7637 35.3835 41.6236C35.5037 41.5976 35.58 41.479 35.554 41.3588C35.528 41.2385 35.4094 41.1622 35.2892 41.1882C34.8823 41.2763 34.481 41.0179 34.3929 40.611L34.114 39.3229L33.9878 38.7401C33.7856 37.8061 34.3789 36.8849 35.3129 36.6827C36.247 36.4805 37.1681 37.0737 37.3703 38.0078L37.4423 38.3403C37.4424 38.3407 37.4425 38.341 37.4426 38.3414L37.7754 39.8786C37.8635 40.2855 37.605 40.6868 37.1981 40.7749C37.0779 40.8009 37.0015 40.9195 37.0276 41.0397C37.0536 41.16 37.1722 41.2363 37.2924 41.2103C37.9397 41.0701 38.3509 40.4317 38.2108 39.7844L37.9319 38.4963L37.9319 38.4963L37.8057 37.9135C37.5514 36.739 36.3932 35.993 35.2187 36.2473Z",
    fill: "#003F66"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5576,
    cy: 16.4757,
    rx: 5.27685,
    ry: 2.77373,
    transform: "rotate(-35.113 19.5576 16.4757)",
    fill: "url(#paint16_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0126,
    cy: 37.7331,
    rx: 1.45071,
    ry: 2.3616,
    transform: "rotate(-35.113 17.0126 37.7331)",
    fill: "url(#paint17_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.2513,
    cy: 20.9987,
    rx: 1.2803,
    ry: 1.1145,
    transform: "rotate(-57.9056 14.2513 20.9987)",
    fill: "url(#paint18_radial)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.976 11.2784L27.04 3.23249C25.3568 2.26073 23.2831 2.26073 21.6 3.23249L7.66398 11.2784C5.98084 12.2502 4.94398 14.0461 4.94398 15.9896V32.0815C4.94398 34.025 5.98084 35.8209 7.66398 36.7927L21.6 44.8386C23.2831 45.8104 25.3568 45.8104 27.04 44.8386L40.976 36.7927C42.6591 35.8209 43.696 34.025 43.696 32.0815V15.9896C43.696 14.0461 42.6591 12.2502 40.976 11.2784ZM28.16 1.2926C25.7838 -0.0793031 22.8562 -0.0793031 20.48 1.2926L6.54398 9.33855C4.16778 10.7104 2.70398 13.2458 2.70398 15.9896V32.0815C2.70398 34.8253 4.16778 37.3607 6.54398 38.7326L20.48 46.7785C22.8562 48.1504 25.7838 48.1504 28.16 46.7785L42.096 38.7326C44.4722 37.3607 45.936 34.8253 45.936 32.0815V15.9896C45.936 13.2458 44.4722 10.7104 42.096 9.33855L28.16 1.2926Z",
    fill: "#E6F4FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.52,
    y1: 8.03555,
    x2: 34.56,
    y2: 41.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 11.52,
    y1: 8.03555,
    x2: 34.56,
    y2: 41.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1154FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16.9837,
    y1: 16.5014,
    x2: 33.6237,
    y2: 26.1014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0843 16.4642) rotate(29.2422) scale(24.8893 33.1574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 18.6245,
    y1: 27.4273,
    x2: 33.4593,
    y2: 29.9843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 20.2655,
    y1: 27.9209,
    x2: 31.9505,
    y2: 30.3005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 22.0335,
    y1: 28.7329,
    x2: 36.8426,
    y2: 32.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECAFF",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF3FF",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 16.7195,
    y1: 34.4827,
    x2: 36.0919,
    y2: 34.4827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.116469,
    stopColor: "#FFAA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699803,
    stopColor: "#FFD84F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF911C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 21.8009,
    y1: 37.7323,
    x2: 43.6582,
    y2: 44.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFF5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7298 36.9072) rotate(42.161) scale(28.721 36.5089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 14.67,
    y1: 35.8285,
    x2: 17.1727,
    y2: 47.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD8300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 39.6563,
    y1: 29.0415,
    x2: 45.4143,
    y2: 47.4095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 11.7006,
    y1: 36.1549,
    x2: 7.18646,
    y2: 37.1322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 5.56939,
    y1: 0,
    x2: 5.56939,
    y2: 11.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 21.2007,
    y1: 40.3042,
    x2: 24.1559,
    y2: 40.9441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CA8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3768 7.35591) rotate(-13.9837) scale(3.04079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.289047,
    stopColor: "#8C4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC68"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7265 14.665) rotate(29.3309) scale(8.89272 10.1963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5847 36.7291) rotate(48.7512) scale(4.21786 4.89218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5643 20.2712) rotate(42.9388) scale(2.5694 3.44034)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542736,
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.db61413829ba3947aa9a5f944043c05b.svg";
export { ForwardRef as ReactComponent };